<template>
    <WorkSchedulePositionsPerGroupLabel
        v-for="(workSchedulePositions, rowIndex) in positionsByRow"
        :key="rowIndex"
        :workSchedulePositions="workSchedulePositions"
        :rowIndex="rowIndex"
        :renderedDateRange="renderedDateRange"
        :groupLabels="groupLabels"
        @dragStart:workSchedulePosition="$emit('dragStart:workSchedulePosition', $event)"
        @dragEnd:workSchedulePosition="$emit('dragEnd:workSchedulePosition', $event)"
    />
</template>

<script lang="ts">
    import WorkSchedulePositionsPerGroupLabel from '@/components/WorkSchedule/WorkSchedulePositionsPerGroupLabel.vue';
    import {PlanbordWorkScheduleGroupLabel, PlanbordWorkSchedulePosition} from '@/types/api-object-extensions';
    import {DateRange, RenderedDay} from '@/types/types';
    import Dates from '@cquential/date-utils';
    import WorkScheduleUtil from '@/util/WorkScheduleUtil';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component({
        components: {
            WorkSchedulePositionsPerGroupLabel,
        },
        emits: [
            'dragStart:workSchedulePosition',
            'dragEnd:workSchedulePosition',
        ],
    })
    export default class WorkSchedulePositionsPerDay extends Vue {
        @Prop({required: true}) public day!: RenderedDay;
        @Prop({required: true}) public groupLabel!: PlanbordWorkScheduleGroupLabel;
        @Prop({required: true}) public groupLabels!: Record<number, PlanbordWorkScheduleGroupLabel>;
        @Prop({required: true}) public renderedDateRange!: DateRange;

        public get positionsByRow(): PlanbordWorkSchedulePosition[][] {
            const positionsToSort: PlanbordWorkSchedulePosition[] = Object.values(Object.values(this.groupLabel.workSchedulePositions ?? {})).filter((workSchedulePosition: PlanbordWorkSchedulePosition): boolean => Dates.compare(workSchedulePosition.beginDateTime).isSameDay(this.day.date)) ?? [];

            const positions: PlanbordWorkSchedulePosition[][] = [];
            for (const position of positionsToSort) {
                const currentRange: DateRange = {
                    begin: position.beginDateTime,
                    end: position.endDateTime,
                };

                const selectedRow: number = positions.findIndex((positions: PlanbordWorkSchedulePosition[]): boolean => positions.every((existingPosition: PlanbordWorkSchedulePosition): boolean => {
                    return !WorkScheduleUtil.isDateRangeOverlapping(currentRange, existingPosition.beginDateTime, existingPosition.endDateTime);
                }));
                if (selectedRow === -1) {
                    positions.push([position]);
                } else {
                    positions[selectedRow].push(position);
                }
            }

            return positions;
        }
    }
</script>
